// extracted by mini-css-extract-plugin
export var smallSpinner = "_qn-0";